export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  // {
  //   field: 'checkbox',
  //   width: 40,
  //   align: 'center',
  //   fixed: 'left',
  //   type: 'checkbox',
  // },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 90,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_amzFirstDemandNo') || '需求单号',
    field: 'amzFirstDemandNo',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_title') || '需求标题',
    field: 'title',
    minWidth: 250,
    align: 'left',
    showHeaderOverflow: true,
  },

  {
    title: that.$l('table_label_amzFirstDemandStatus') || '状态',
    field: 'amzFirstDemandStatus',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'status' },
  },
  {
    title: that.$l('form_label_skuSalesChannel') || '产品类型',
    field: 'v_skuSalesChannel',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'skuSalesChannel' },
  },
  {
    title: that.$l('table_label_designName') || '负责企划',
    field: 'designName',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_operateName') || '负责运营',
    field: 'operateName',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_created_by') || '创建人',
    field: 'createByName',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_created_date') || '创建时间',
    field: 'createDate',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    field: 'modifyDate',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
